"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChevronUpCircle = exports.ChevronUp = exports.ChevronRightCircle = exports.ChevronRight = exports.ChevronLftCircle = exports.ChevronLft = exports.ChevronDwnCircle = exports.ChevronDwn = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ChevronDwnSvg = function ChevronDwnSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Down"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#25292D",
    d: "M4.354 5.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 1 0-.708-.708L8 9.293 4.354 5.646z"
  }));
};

ChevronDwnSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronDwnCircleSvg = function ChevronDwnCircleSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Circle Down"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zM5.204 7.317a.5.5 0 0 1 .707 0l2.09 2.09 2.088-2.09a.5.5 0 0 1 .707.707l-2.442 2.443a.5.5 0 0 1-.707 0L5.204 8.024a.5.5 0 0 1 0-.707z"
  }));
};

ChevronDwnCircleSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronLftSvg = function ChevronLftSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Left Less Than"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.354 1.354a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 1 0 .708-.708L1.707 5l3.647-3.646z"
  }));
};

ChevronLftSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronLftCircleSvg = function ChevronLftCircleSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Circle Left Less Than"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm.422 3.203a.5.5 0 0 1 .707.707L7.04 8l2.089 2.09a.5.5 0 0 1-.707.706L5.98 8.353a.5.5 0 0 1 0-.707z"
  }));
};

ChevronLftCircleSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronRightSvg = function ChevronRightSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Right Greater Than"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.646 8.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L4.293 5 .646 8.646z"
  }));
};

ChevronRightSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronRightCircleSvg = function ChevronRightCircleSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Circle Right Greater Than"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#25292D",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zM6.871 5.203a.5.5 0 0 1 .707 0l2.442 2.444a.5.5 0 0 1 0 .707l-2.442 2.443a.5.5 0 0 1-.707-.707L8.96 8 6.87 5.91a.5.5 0 0 1 0-.707z"
  }));
};

ChevronRightCircleSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronUpSvg = function ChevronUpSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Up"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.646 5.354a.5.5 0 1 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 .708.708L5 1.707l3.646 3.647z"
  }));
};

ChevronUpSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronUpCircleSvg = function ChevronUpCircleSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Chevron Arrow Up Circle"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm-.354 4.426a.5.5 0 0 1 .707 0l2.443 2.442a.5.5 0 0 1-.707.707L8 7.486 5.912 9.575a.5.5 0 1 1-.707-.707z"
  }));
};

ChevronUpCircleSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var ChevronDwn = function ChevronDwn() {
  return /*#__PURE__*/_react["default"].createElement(ChevronDwnSvg, null);
};

exports.ChevronDwn = ChevronDwn;

var ChevronDwnCircle = function ChevronDwnCircle() {
  return /*#__PURE__*/_react["default"].createElement(ChevronDwnCircleSvg, null);
};

exports.ChevronDwnCircle = ChevronDwnCircle;

var ChevronLft = function ChevronLft() {
  return /*#__PURE__*/_react["default"].createElement(ChevronLftSvg, null);
};

exports.ChevronLft = ChevronLft;

var ChevronLftCircle = function ChevronLftCircle() {
  return /*#__PURE__*/_react["default"].createElement(ChevronLftCircleSvg, null);
};

exports.ChevronLftCircle = ChevronLftCircle;

var ChevronRight = function ChevronRight() {
  return /*#__PURE__*/_react["default"].createElement(ChevronRightSvg, null);
};

exports.ChevronRight = ChevronRight;

var ChevronRightCircle = function ChevronRightCircle() {
  return /*#__PURE__*/_react["default"].createElement(ChevronRightCircleSvg, null);
};

exports.ChevronRightCircle = ChevronRightCircle;

var ChevronUp = function ChevronUp() {
  return /*#__PURE__*/_react["default"].createElement(ChevronUpSvg, null);
};

exports.ChevronUp = ChevronUp;

var ChevronUpCircle = function ChevronUpCircle() {
  return /*#__PURE__*/_react["default"].createElement(ChevronUpCircleSvg, null);
};

exports.ChevronUpCircle = ChevronUpCircle;